
import $ from "jquery"
import URI from "urijs"

import Cookies from "plugins/cookies-js/index"
import {
  requestIdleCallback,
} from "plugins/request-animation-frame-polyfill"

import WaitObjectByPathPromise from "app/wait_object_by_path_promise"
import MobileOsDetection from "app/detection/mobile_os"
import DataRetriever from "app/data_retriever"
import Goal_track from "app/tracking/goals/track"
import MobileListerAppSmartBanner from "./index"

const {isIOS , isAndroid} = MobileOsDetection


import I18n from "plugins/i18n-js"


const DONT_SHOW_MOBILE_SMART_BANNER = "dont_show_lister_app_smartbanner"


const showBannerWithCooldownForMobile = () => {
  let deep_link_url = null as null|string
  if (isIOS()) {
    deep_link_url = $("meta[property=\"al:ios:url\"]").attr("content")
  }


  if (isAndroid()){
    deep_link_url = $("meta[property=\"al:android:url\"]").attr("content")
  }

  if (deep_link_url == null) {
    MobileListerAppSmartBanner.hide()
  }

  let download_link = null as null|string

  if (isAndroid()){
    const is_user_in_china = DataRetriever.get("current-location-country-code-is-china")

    if ( is_user_in_china ){
      download_link = "http://cdn.spacious.hk/spacious/mobile_lister_app/releases/official/latest/android/SpaciousLister.apk"
    }
    else{
      const url_object = URI("https://play.google.com/store/apps/details")
      url_object.addSearch("id", "spacious.lister")
      url_object.addSearch("hl", I18n.locale) // locale attr on the Play Store
      url_object.addSearch("referrer", `utm_source=${location.hostname}&utm_medium=smart-banner&utm_campaign=${location.pathname}`)

      download_link = url_object.toString()
    }
  }

  if (isIOS()){
    download_link = "https://itunes.apple.com/app/apple-store/id1021918239?pt=95954229&ct=website-smartbanner&mt=8"
  }

  $(".cell--mobile-apps--lister-app--smart-banner--default-style__btn--install-app").on("click", () => {
    if (typeof download_link === "string") {
      window.location.href = download_link
    }

    // Track Mobile App Download Leads
    Goal_track.MobileAppDownloadLead.track("download link clicked on Lister App smartbanner")
  })

  $(".cell--mobile-apps--lister-app--smart-banner--default-style__btn--open-app").on("click", () => {
    if (typeof deep_link_url === "string") {
      window.location.href = deep_link_url
    }
  })

  $(".cell--mobile-apps--lister-app--smart-banner--default-style__close-banner-button").on("click", () => {
    MobileListerAppSmartBanner.hide()
    Cookies.set(DONT_SHOW_MOBILE_SMART_BANNER, true, {expires: 86400}) // If banner closed, don"t show for 1 day
  })

}


const onLoad = () => {
  requestIdleCallback(() => {
    WaitObjectByPathPromise("window._spacious_main_css_loaded")
    .then(() => {
      requestIdleCallback(() => {
        showBannerWithCooldownForMobile()
      })
    })
    .done()
  })
}

export default {onLoad}



